import { getAccessToken, getUser, refreshToken } from "@newsenec/auth-provider";
import { buildFetchErrorMessage } from "@newsenec/logging";

async function postRegistration(devNumber: number, inviteCode: string) {
    const token = await getAccessToken();
    const user = await getUser();

    const localUrl = new URL(location.origin + "/api/fpp/registerUser");
    localUrl.searchParams.append("devNumber", devNumber.toString());
    localUrl.searchParams.append("invitationCode", inviteCode);
    localUrl.searchParams.append("email", user?.email ?? "");
    const method = "POST";

    const response = await fetch(localUrl, {
        method,
        headers: {
            Authorization: "Bearer " + token,
        },
        body: token,
    });

    return response.ok ? refreshToken() : Promise.reject({ response, message: buildFetchErrorMessage(method, response) });
}

export async function register(devNumber: number, invitationCode: string) {
    return postRegistration(devNumber, invitationCode);
}
